import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import ContactUs from 'components/HomePageNew/ContactUs';

const ContactUsPageNew = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <ContactUs {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default ContactUsPageNew;
